









































































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class TongueWenli extends Vue {
  @Prop()
  private r: any;
}
